import React, { Component } from 'react';
import _ from 'lodash';
import AvailableButton from './AvailableButton';
import details from './details';

import './AvailableButtons.css';

class AvailableButtons extends Component {
  render() {
    const createWebfontsMarkup = () => {
      return {__html: this.props.webFontEmbeds};
    };

    const purifiedStylesUrl = `${details.apiUrl}/styles/?site_id=${this.props.context.id}`;

    return (
      <div className="AvailableButtons">
        <div className="AvailableButtons__webfonts" dangerouslySetInnerHTML={createWebfontsMarkup()} />
        <div className="AvailableButtons__stylesheets">
          <link rel="stylesheet" href={purifiedStylesUrl} />
          <style>{this.props.context.inline_styles}</style>
        </div>
        <div className="AvailableButtons__grid">
          {_.map(this.props.availableClasses, (availableClass, i) => {
            return <AvailableButton key={i} i={i} ctaClass={availableClass} ctaString={this.props.ctaString} context={this.props.context} />;
          })}
        </div>
      </div>
    );
  }
}

export default AvailableButtons;



// WEBPACK FOOTER //
// ./src/AvailableButtons.js